// extracted by mini-css-extract-plugin
export default {"task":"styles_task__o0H1R","main_section":"styles_main_section__UtgEc","left_banner":"styles_left_banner__e44jt","right_section":"styles_right_section__829MN"};